'use client';

import {createContext, MutableRefObject, use} from 'react';

import {LandingPageContextState, LandingPageReducerState} from './index.d';

/*
 * Kept out of the provider's own file so that file exports only a component.
 * A module that exports both a component and non-components defeats Fast
 * Refresh: editing it remounts the tree instead of preserving state.
 *
 * Split into two contexts: the reducer state (only changes when `isSticky`
 * actually flips) and the container ref (a stable `useRef`, never
 * reassigned). Neither needs re-wrapping in a fresh object on every render.
 */
export const LandingPageStateContext =
  createContext<LandingPageReducerState>(null);
export const LandingPageRefContext =
  createContext<MutableRefObject<HTMLElement>>(null);

export const useLandingPageContextValue = (): LandingPageContextState => {
  const state = use(LandingPageStateContext);
  const containerInstance = use(LandingPageRefContext);

  return {...state, containerInstance};
};
